import {Component, Input} from '@angular/core';
@Component({
  selector: 'bounce',
  styleUrls: ['./bounce.less'],
  templateUrl: './bounce.html'
})
export class Bounce {
  @Input() type: string;
}
